import { formatDateISO } from '@safetyhub/shared';

/**
 * 오늘을 `yyyy-MM-dd`(**브라우저 로컬** 날짜)로 — `<input type="date">`·`DateInput`의 값·`min`/`max`.
 *
 * ⚠️ `new Date().toISOString().split('T')[0]`을 쓰지 말 것 — 그것은 **UTC** 날짜라 KST 00:00~09:00에는
 * 「오늘」이 어제가 된다(리뷰 1103 F7 — 일정 변경 요청의 `min`이 하루 앞으로 열렸다).
 *
 * 이 모듈에 둔 이유: 같은 함수가 법정 서류 모달 넷·역할 배정 모달에 손사본으로 있었다(리뷰 1103 F8).
 * `lib/inspections`의 `getLocalDateString`과 같은 계산이지만 그 모듈은 spec 십여 개가 `vi.mock`하므로
 * 거기서 import하면 그 spec들이 「export가 mock에 없다」로 죽는다 — mock 대상 밖에 둔다.
 *
 * 법정 서류는 이 함수를 쓰지 않는다 — 아래 `todayDateInputInTimezone`(현장 시간대)을 쓴다(2026-11-03 P2).
 */
export function todayLocalDateInput(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * 오늘을 `yyyy-MM-dd`(**그 시간대**의 날짜)로 — 법정 서류 입력(2026-11-03 P2). 서버가 기간·기한을 현장 유효 시간대로 파생하므로
 * 화면의 「오늘」(`max`·초기값)도 그 시간대여야 한다 — 브라우저 로컬을 쓰면 시간대가 다른 현장에서 「미래」 판정이 하루 갈린다.
 * 시간대는 서버 응답 `LegalObligationsResponse.timezone`(현장 > 조직)에서 온다. 브라우저 로컬 판(`todayLocalDateInput`)은
 * 법정 서류 밖 소비처(일정 변경 요청)가 쓰므로 남긴다.
 */
export function todayDateInputInTimezone(timezone: string, now: Date = new Date()): string {
  return formatDateISO(now, timezone);
}
